import {ref} from 'vue';

export const loaded = ref({
    active: true,
    animation: false
});

